import type { MouseEvent } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

export const NotAuthenticatedWidget = () => {
	const { login } = useAuth();

	const handleLogin = (e: MouseEvent) => {
		e.preventDefault();
		login();
	};

	return (
		<div className="h-full flex items-center justify-center">
			<span className="text-lg text-light-gray">
				Please{" "}
				<Button variant="link" onClick={handleLogin}>
					login
				</Button>
			</span>
		</div>
	);
};
